/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:14:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 16:36:43
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import {
  getAllProductsPage,
  postAllProductsPage,
} from '@/src/request/salesChannel/content';
import { wrapperDataFromServerToRedux } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import {
  generateDefaultState as _generateDefaultState,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
  hasError,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import { msg } from 'src/tools/message';

import {
  EnumCollapseId,
  fixedCollapse,
  generateDefaultProductMenu,
  generateDefaultTopLeaderBoardBanner,
} from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/common';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseStatus as _getCollapseStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { convertDataFromServerToRedux } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/tools';
export { EnumCollapseId };

export const fetchContentAllProductsPage = createAsyncThunk(
  'fetchSalesChannelContentAllProductsPage',
  async (
    data: any,
    //thunkAPI,
  ) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getAllProductsPage(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitContentAllProductsPage = createAsyncThunk(
  'submitSalesChannelContentAllProductsPage',
  async ({ body, params }: any) => {
    const { uuid } = body;
    const isPrimary = isCurrentPrimary();
    const response = await postAllProductsPage(body, params || {});
    return { response, isNew: !!!uuid, isPrimary };
  },
);

const _defaultContent = {
  topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
  productMenu: generateDefaultProductMenu(),
};

const _defaultState = _generateDefaultState(fixedCollapse, _defaultContent);
const defaultState = {
  ..._defaultState,
  ...defaultStatus,
};
const salesChannelContentAllProductsPage = createSlice({
  name: 'salesChannelContentAllProductsPage',
  initialState: defaultState,
  reducers: {
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },

    onTopLeaderBoardBannerChange(state, action) {
      state.hasModified = true;
      state.topLeaderBoardBanner.linkModule = {
        ...state.topLeaderBoardBanner.linkModule,
        ...action.payload,
      };
    },

    onTopLeaderBoardBannerEnabledChange(state, action) {
      state.hasModified = true;
      state.topLeaderBoardBanner = {
        ...state.topLeaderBoardBanner,
        ...action.payload,
      };
    },

    onProductMenuChange(state, action) {
      state.hasModified = true;
      state.productMenu = {
        ...state.productMenu,
        ...action.payload,
      };
    },
    onMiniProgramShareChange(state, action) {
      state.hasModified = true;
      state.miniProgramShare = {
        ...state.miniProgramShare,
        ...action.payload,
      };
    },
    onGridSettingChange(state, action) {
      state.hasModified = true;
      state.gridSetting = {
        ...state.gridSetting,
        ...action.payload,
      };
    },
    onProductMenuAdd(state, action) {
      state.hasModified = true;
      state.productMenu.roots.push(action.payload);
    },

    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },

    resetData(state) {
      assData(state, defaultState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContentAllProductsPage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchContentAllProductsPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchContentAllProductsPage.fulfilled, (state, action) => {
      const { response, isPrimary, isClone } = action.payload;
      const _data = wrapperDataFromServerToRedux(
        response || {},
        isPrimary,
      )(convertDataFromServerToRedux);

      assData(state, _data);

      if (isClone) state.hasModified = true;
    });
    builder.addCase(submitContentAllProductsPage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitContentAllProductsPage.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentAllProductsPage.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data: any = wrapperDataFromServerToRedux(
        response || {},
        isPrimary,
      )(convertDataFromServerToRedux);

      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, { ..._data });
    });
  },
});

export const {
  onCollapseOpen,
  validation,
  onErrorChange,
  resetData,
  onTopLeaderBoardBannerChange,
  onProductMenuChange,
  onProductMenuAdd,
  onTopLeaderBoardBannerEnabledChange,
  onMiniProgramShareChange,
  onGridSettingChange,
} = salesChannelContentAllProductsPage.actions;

export default salesChannelContentAllProductsPage.reducer;

export const getTopLeaderBoardBanner = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.allProductsPage]
        .topLeaderBoardBanner,

    (topLeaderBoardBanner) => {
      return topLeaderBoardBanner;
    },
  );
};

export const getProductMenu = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.allProductsPage].productMenu,

    (productMenu) => {
      return productMenu;
    },
  );
};

export const getGridSetting = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.allProductsPage].gridSetting,

    (gridSetting) => {
      return gridSetting;
    },
  );
};

export const getContent = (wrapper) => {
  const productMenu = wrapper(getProductMenu());
  const topLeaderBoardBanner = wrapper(getTopLeaderBoardBanner());
  return {
    productMenu,
    topLeaderBoardBanner,
  };
};

export const getLoaded = () => {
  return _getLoaded(EnumReducers.allProductsPage);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.allProductsPage);
};

export const getState = () => {
  return _getState(EnumReducers.allProductsPage);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.allProductsPage);
};

export const getCollapseStatus = (id) => {
  return _getCollapseStatus(EnumReducers.allProductsPage, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.allProductsPage, id);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.allProductsPage);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.allProductsPage);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.allProductsPage, id);
};

export const getGeneralMiniProgramShare = () => {
  return _getGeneralMiniProgramShare(EnumReducers.allProductsPage);
};

export const getGeneralMiniProgramPageInfo = () => {
  return _getGeneralMiniProgramPageInfo(EnumReducers.allProductsPage);
};
